import { createReducer } from '@reduxjs/toolkit';
import * as ua from './utilActions';
import { buildActionStatus, actionManager } from '../utils';

const actionStatus = buildActionStatus(ua);

const initialState = {
  actionStatus: actionStatus,
  push: null,
  open: false,
  message: '',
  type: 'info',
  icon: '',
  notiPopoutName: '',
  duration: 5000,
};

const utilsReducer = createReducer(initialState, {
  [ua.initAction]: (state, { payload: { key } }) =>
    actionManager(state, key, { loading: true, error: '' }),
  [ua.successAction]: (state, { payload: { key } }) =>
    actionManager(state, key, { loading: false, error: '' }),
  [ua.errorAction]: (state, { payload: { key, error } }) =>
    actionManager(state, key, { loading: false, error }),
  [ua.setPushAction]: (state, { payload: { push } }) => ({ ...state, push }),
  [ua.setNotificationAction]: (
    state,
    { payload: { message, type, icon, notiPopoutName, duration } }
  ) => ({
    ...state,
    open: true,
    message,
    type,
    notiPopoutName,
    duration,
    icon,
  }),
  [ua.closeNotificationAction]: (state) => ({ ...state, open: false }),
});

export default utilsReducer;
